import { useMutation } from "react-query";

import { bulkRefreshInventoryCodes } from "@/api/Inventories/Inventory/codes-bulk-refresh-api";

export const bulkRefreshCodesKey = "bulk-refresh-codes";

export function useBulkRefreshCodes() {
	return useMutation(bulkRefreshInventoryCodes);
}
